import { ChangeDetectionStrategy, Component, inject, NgZone, signal } from '@angular/core';
import gsap from "gsap";

@Component({
  selector: 'skyscraper2',
  standalone: false,
  templateUrl: './skyscraper2.component.html',
  styleUrl: './skyscraper2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Skyscraper2Component {
  private zone = inject(NgZone);
  public finalHeight = signal<number>(600); 
  public height = signal<number>(200);


  ngAfterViewInit(): void {
    this.animate();
  }

  animate() {
    const obj = { x: this.height() };
    gsap.to(obj, {
      x: this.finalHeight(),
      duration: 1,
      delay: 0,
      ease: "power2.inOut",
      onUpdate: () => {
        this.zone.run(() => {
          this.height.set(obj.x);
        });
      },
    });
  }
}
